// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer__Footer__2Vwrr","FooterMessage":"Footer__FooterMessage__2b5Ed"};